import { ServerConfig } from "@/config/config";
import { DeletedPurchase } from "@/models/base/deleted-purchase";
import { Axios } from "@/utils/axios";
import { IGetResponse } from "@/utils/get-response";

export class DeletedPurchasesServiceClass {
	public readonly url = ServerConfig.host + "/deleted-purchases";

	public async getDeletedPurchases(limit:number, offset:number, order:string, orderDirection:"ASC" | "DESC"):Promise<IGetResponse<DeletedPurchase>> {
		let result = await Axios.get(this.url, {params: {
			limit,
			offset,
			order,
			orderDirection
		}});
		return {
			records: result.data.records,
			data: ((result.data.data || []) as any[]).map(d=>new DeletedPurchase(d))
		};
	}
}

export const DeletedPurchasesService = new DeletedPurchasesServiceClass();